import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { AudioManager } from "../../../AudioManager";
import { CombosContainer } from "./CombosContainer";
import * as Candy from "@ravalmatic/candy-engine";
import { ScoreContainer } from "../../../utils/ScoreContainer";

export class HUD extends Phaser.GameObjects.Container {

    private upperContainer: Phaser.GameObjects.Container;
    private movesLabel: Phaser.GameObjects.BitmapText;
    private movesLabelAlert: Phaser.GameObjects.BitmapText;
    private movesLabelAlertTween: Phaser.Tweens.Tween;
    private combosContainer: CombosContainer;
    private scoreContainer: ScoreContainer;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.upperContainer = new Phaser.GameObjects.Container(this.scene);
        this.upperContainer.x = GameConstants.GAME_WIDTH / 2;
        this.upperContainer.y = 15 * GameVars.scaleY;
        this.upperContainer.scaleY = GameVars.scaleY;
        this.add(this.upperContainer);
       
        const background = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_6", "hud_box");
        background.setOrigin(.5, 0);
        this.upperContainer.add(background);

        this.scoreContainer = new ScoreContainer(this.scene, "texture_atlas_1", -8);
        this.scoreContainer.x = -10;
        this.scoreContainer.updateScore(0);
        this.scoreContainer.y = 110;
        this.upperContainer.add(this.scoreContainer);

        this.movesLabel = new Phaser.GameObjects.BitmapText(this.scene, 265, 105, "baloo-cyan", GameVars.candyEngine.moves.toString(), 80);
        this.movesLabel.setOrigin(.5);
        this.upperContainer.add(this.movesLabel);

        this.combosContainer = new CombosContainer(this.scene);
        this.add(this.combosContainer);

        this.movesLabelAlert = null;
        this.movesLabelAlertTween = null;
    }

    public update(): void {

        this.combosContainer.update();
    }

    public onLevelUp(): void {

        const levelUpLabel = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH * 1.5, GameConstants.GAME_HEIGHT / 2, "texture_atlas_5", "text_level_up");
        levelUpLabel.scaleY = GameVars.scaleY;
        this.add(levelUpLabel);

        this.scene.tweens.add({
            targets: levelUpLabel,
            x: GameConstants.GAME_WIDTH * .5,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            onComplete: function(): void {

                this.scene.tweens.add({
                    targets: levelUpLabel,
                    x: -GameConstants.GAME_WIDTH * .5,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 350,
                    delay: 750,
                    onComplete: function(): void {
                        levelUpLabel.destroy();
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });

        AudioManager.playSound("new_level");
    }

    public onReshuffle(): void {
        
        const noMovesLabel = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 - 40, "texture_atlas_5", "text_no_moves");
        noMovesLabel.scaleY = GameVars.scaleY;
        this.add(noMovesLabel);

        const reshuffleLabel = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 + 40, "texture_atlas_5", "text_reshuffle");
        reshuffleLabel.scaleY = GameVars.scaleY;
        this.add(reshuffleLabel);

        noMovesLabel.setScale(0);

        this.scene.tweens.add({
            targets: noMovesLabel,
            scaleX: 1,
            scaleY: GameVars.scaleY,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 600
        });

        this.scene.tweens.add({
            targets: noMovesLabel,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 400,
            delay: 2000,
            onComplete:  function(): void {
                noMovesLabel.destroy();
            }, 
            onCompleteScope: this
        });

        reshuffleLabel.setScale(0);

        this.scene.tweens.add({
            targets: reshuffleLabel,
            scaleX: 1,
            scaleY: GameVars.scaleY,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 600,
            delay: 500,
        });

        this.scene.tweens.add({
            targets: reshuffleLabel,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 400,
            delay: 2300,
            onComplete:  function(): void {
                reshuffleLabel.destroy();
            }, 
            onCompleteScope: this
        });
    }

    public updateScore(orbsEliminated: number, rematchesCounter?: number): void {

        rematchesCounter = rematchesCounter || 0;

        let deltaScoreOrbs: number;
        
        if (rematchesCounter < 3) {
            deltaScoreOrbs = GameVars.score - this.scoreContainer.getScore();
        } else {
            deltaScoreOrbs = GameVars.score - this.scoreContainer.getScore() - rematchesCounter * Candy.Engine.POINTS_PER_REMATCH;
        }
        
        this.scoreContainer.updateScore(GameVars.score);

        const delay = orbsEliminated * 10;

        if (deltaScoreOrbs > 0) {
            
            const deltaScoreLabel = new Phaser.GameObjects.Text(this.scene, -20, 190, "+" + GameVars.formatNumber(deltaScoreOrbs), {fontFamily: "Baloo", fontSize: "60px", align: "center", color: "#fff364"});
            deltaScoreLabel.setOrigin(.5);
            this.upperContainer.add(deltaScoreLabel);
    
            this.scene.tweens.add({
                targets: deltaScoreLabel,
                y: 110,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 500,
                delay: 200 + delay
            });   
        }

        if (rematchesCounter !== 0) {

            if (rematchesCounter >= 3) {

                let i = rematchesCounter - 3;
                i = i % CombosContainer.LABEL_COLOURS.length;

                let str = CombosContainer.LABEL_COLOURS[i].toString(16);

                if (str.length === 5) {
                    str = "0" + str;
                }

                const color = "#" + str;

                const deltaScoreRematchesLabel = new Phaser.GameObjects.Text(this.scene, -20, 240, "+" + GameVars.formatNumber(rematchesCounter * Candy.Engine.POINTS_PER_REMATCH), {fontFamily: "Baloo", fontSize: "60px", align: "center", color: color});
                deltaScoreRematchesLabel.setOrigin(.5);
                this.upperContainer.add(deltaScoreRematchesLabel);
        
                this.scene.tweens.add({
                    targets: deltaScoreRematchesLabel,
                    y: 110,
                    alpha: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 700,
                    delay: delay + 400 
                });
            }
            
            this.combosContainer.onRematch(rematchesCounter);

        } else {
            this.combosContainer.onNoRematch();
        }
    }

    public updateMoves(): void {

        this.movesLabel.text = GameVars.candyEngine.moves.toString();

        if (this.movesLabelAlert) {
            this.movesLabelAlert.text = GameVars.candyEngine.moves.toString();
        }

        if (GameVars.candyEngine.moves === 5 && !this.movesLabelAlert) {

            this.movesLabelAlert = new Phaser.GameObjects.BitmapText(this.scene, 265, 105, "baloo-red", GameVars.candyEngine.moves.toString(), 80);
            this.movesLabelAlert.setOrigin(.5);
            this.upperContainer.add(this.movesLabelAlert);

            this.movesLabelAlertTween = this.scene.tweens.add({
                targets: this.movesLabelAlert,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.InOut,
                duration: 750,
                yoyo: true,
                repeat: -1
            });
        }
    }

    public onGameOver(): void {

        if (this.movesLabelAlert) {
            this.movesLabelAlertTween.stop();
            this.movesLabelAlert.alpha = 1;
        }
    }
}
